import { useTheme } from "../../context/ThemeProvider";
import { useTranslateText } from "../../hooks/useTranslateText";
import { IoMoon, IoSunny } from "react-icons/io5";

const ThemeToggleFromSettings = () => {
  // @ts-ignore
  const { theme, toggleTheme } = useTheme();
  const translate = useTranslateText();
  const isDark = theme === "dark";

  return (
    <button
      type="button"
      className="flex w-full items-center justify-between gap-3 px-4 py-3.5 text-left active:bg-black/[0.04] dark:active:bg-white/[0.06]"
      onClick={() => toggleTheme()}
    >
      <div className="flex items-center gap-3">
        <span className="text-themeColor">
          {isDark ? (
            <IoSunny className="text-xl" />
          ) : (
            <IoMoon className="text-xl" />
          )}
        </span>
        <span className="text-[15px] text-darkText">
          {isDark ? translate("Light mode") : translate("Dark mode")}
        </span>
      </div>
      <span
        className={`relative h-[28px] w-[48px] shrink-0 rounded-full transition-colors ${
          isDark ? "bg-themeColor" : "bg-black/15 dark:bg-white/20"
        }`}
      >
        <span
          className={`absolute top-[2px] h-6 w-6 rounded-full bg-white shadow transition-transform ${
            isDark ? "translate-x-[22px]" : "translate-x-[2px]"
          }`}
        />
      </span>
    </button>
  );
};

export default ThemeToggleFromSettings;
